import { render, staticRenderFns } from "./IDialog.vue?vue&type=template&id=5b6392d7&scoped=true"
import script from "./IDialog.vue?vue&type=script&lang=ts"
export * from "./IDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6392d7",
  null
  
)

export default component.exports